// extracted by mini-css-extract-plugin
export default {"table-header":"table_table-header__7Nhi3","table-container":"table_table-container__IbG7A","table-row":"table_table-row__1R3QB","container":"table_container__Tt7Vd"};